import { GitpodAPI } from "@/api";
import { type FC, type PropsWithChildren, createContext } from "react";

// @ts-expect-error Can't initialize context with empty object
export const GitpodAPIContext = createContext<GitpodAPI>();

export const GitpodAPIProvider: FC<PropsWithChildren> = ({ children }) => {
    return <GitpodAPIContext.Provider value={GitpodAPI}>{children}</GitpodAPIContext.Provider>;
};
